import React, { useContext } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { StMissionTimeline } from 'stserver-frontend-comp';
import { serverContext, themeContext } from '../App';

const useStyles = makeStyles(theme => ({
    root: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    paper: {
        width: '100%',
        height: '100%',
        border: "solid 1px #ddd",
        borderRadius: '8px'
    },
    timelineThemeOverrides: {
        '& .recharts-dot, & .recharts-scatter-dot, & .recharts-reference-dot': {
            fill: `${theme.palette.primary.main} !important`,
            stroke: `${theme.palette.background.paper} !important`,
        },
        '& .recharts-symbols': {
            fill: `${theme.palette.primary.main} !important`,
            stroke: `${theme.palette.background.paper} !important`,
        },
        '& .recharts-wrapper, & svg': {
            backgroundColor: `${theme.palette.background.paper} !important`,
        },
        '& .recharts-layer text, & .recharts-cartesian-axis-tick-value': {
            fill: `${theme.palette.text.primary} !important`,
            color: `${theme.palette.text.primary} !important`,
        },
        '& .recharts-cartesian-axis-tick-line, & .recharts-cartesian-grid line': {
            stroke: `${theme.palette.divider} !important`,
        },
        '& svg circle': {
            fill: `${theme.palette.primary.main} !important`,
            stroke: `${theme.palette.background.paper} !important`,
        },
    },
}));



/**
 * Timeline renders the timeline on the available missions
 * 
 * TODO: Add timeline
 * @param  {} props
 */
function CurrentMissionTimeline(props) {
    const { server } = useContext(serverContext);
    const themeCtx = useContext(themeContext);
    const classes = useStyles();
    const muiTheme = useTheme();
    const themeMode = themeCtx?.mode === 'dark' ? 'dark' : 'light';
    const timelineTextColor = muiTheme.palette.text.primary;
    const timelineBgColor = muiTheme.palette.background.paper;
    const timelineGridColor = muiTheme.palette.divider;
    const timelineCrosshairColor = muiTheme.palette.primary.main;

    return (
            <Grid container className={classes.root} spacing={2}>
                <Grid item justifyContent="center" spacing={2} className={`${classes.paper} ${classes.timelineThemeOverrides}`}>                   
                  <StMissionTimeline
                    serverUrl={server.serverHost}
                    missionIdOrName={props.missionName}
                    curPos={props.curPos}
                    username={server.username}
                    password={server.password}
                    serverToken={server.token}
                    gridOpacity={0.24}
                    bookmarksUpdateTime={props.bookmarksUpdateTime}
                    onMouseCrosshairDown={props.onTimelineCrosshairClick}
                    onBookmarkClick={props.onBookmarkClick}
                    theme={themeMode}
                    textColor={timelineTextColor}
                    backgroundColor={timelineBgColor}
                    gridColor={timelineGridColor}
                    crosshairColor={timelineCrosshairColor}
                  />                
                </Grid>
            </Grid>
    );
}

export default CurrentMissionTimeline;
